import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/**
 * @description 登录、获取用户信息、退出登录、清除token逻辑，不建议修改
 */
import { useAclStore } from "./acl";
import { useTabsStore } from "./tabs";
import { useRoutesStore } from "./routes";
import { useSettingsStore } from "./settings";
import { encryptedRsa } from "@/utils/encrypt";
import { getLogin, getsmsLogin, Aespost } from "@/api/user";
import { getToken, removeToken, setToken } from "@/utils/token";
import { resetRouter } from "@/router";
import { tokenName } from "@/config";
import { getCityApi } from "@/api/api";
import { getbdAreaApi } from "@/api/common";
import { gp } from "@gp";
export const useUserStore = defineStore("user", {
  state: () => ({
    token: getToken(),
    username: "游客",
    avatar: "https://i.gtimg.cn/club/item/face/img/2/15922_100.gif",
    rsaKey: "",
    vipInfos: {},
    cityInfo: {},
    cityList: [],
    authCode: [],
    areaList: []
  }),
  getters: {
    getToken: state => state.token,
    getUsername: state => state.username,
    getAvatar: state => state.avatar
  },
  actions: {
    /**
     * @description 设置token
     * @param {*} token
     */
    setToken(token) {
      this.token = token;
      setToken(token);
    },
    /**
     * @description 设置用户名
     * @param {*} username
     */
    setUsername(username) {
      this.username = username;
    },
    /**
     * @description 设置头像
     * @param {*} avatar
     */
    setAvatar(avatar) {
      this.avatar = avatar;
    },
    /**
     * @description 设置token并发送提醒
     * @param {string} token 更新令牌
     * @param {string} tokenName 令牌名称
     */
    afterLogin(token, tokenName) {
      sessionStorage.setItem("userNames", tokenName);
      const settingsStore = useSettingsStore();
      if (token) {
        this.setToken(token);
        const hour = new Date().getHours();
        const thisTime = hour < 8 ? "早上好" : hour <= 11 ? "上午好" : hour <= 13 ? "中午好" : hour < 18 ? "下午好" : "晚上好";
        gp.$baseNotify(`欢迎登录${settingsStore.title}`, `${thisTime}！`);
      } else {
        const err = `登录接口异常，未正确返回${tokenName}...`;
        gp.$baseMessage(err, "error", "vab-hey-message-error");
        throw err;
      }
    },
    /**
     * @description 登录
     * @param {*} userInfo
     */
    async login(userInfo) {
      let data = {};
      if (userInfo.type == "sms") {
        data = await getsmsLogin(userInfo);
      } else {
        data = await getLogin(userInfo);
      }
      this.rsaKey = encryptedRsa(data.data.key);
      this.token = data.data.auth;
      const res = await Aespost({
        key: this.rsaKey
      });
      if (res.data == "true") {
        this.afterLogin(data.data.auth, tokenName);
      }
    },
    /**
     * @description 获取用户区域权限
     */
    // 获取省市区并选中第一个权限区域
    async getCityobj(data) {
      this.authCode = data?.split(",") || [];
      this.getareaobj();
      const res = await getCityApi({});
      if (res.code === 200) {
        let matchedItems = {}; // 用于存储匹配的项
        let parentChain = []; // 用于存储父级链
        const processCityData = (data, parentDisabled = true, parents = []) => {
          return data.map(item => {
            const isAuthorized = this.authCode.includes(item.code);
            const disabled = parentDisabled ? !isAuthorized : false;
            const processedItem = {
              ...item,
              value: item.code,
              label: item.name,
              disabled
            };
            if (item.code === this.authCode[0]) {
              matchedItems = processedItem;
              parentChain = [...parents];
            }
            const currentItemInfo = {
              value: processedItem.value,
              label: processedItem.label,
              code: processedItem.code
            };
            const children = item.city || item.area;
            if (children) {
              processedItem.children = processCityData(children, processedItem.disabled, [...parents, currentItemInfo]);
            }
            delete processedItem.city; //删除掉city字段
            delete processedItem.area; //删除掉area字段
            return processedItem;
          });
        };
        this.cityList = processCityData(res.data);
        if (matchedItems) {
          parentChain.push(matchedItems);
          // 只有两级的时候要处理parentChain
          this.cityInfo = {
            label: matchedItems.label,
            value: matchedItems.value,
            BDcode: matchedItems.baidu_blockId,
            id: parentChain.length,
            province: 53,
            city: parentChain[0]?.code || "",
            area: parentChain[1]?.code || ""
          };
        }
      }
    },
    // 获取景区数据
    async getareaobj() {
      const res = await getbdAreaApi({});
      if (res.code === 200) {
        this.areaList = res.data;
      }
    },
    /**
     * @description 退出登录
     */
    async logout() {
      // await getLogout();
      await this.resetAll();
      // 解决横向布局退出登录显示不全的bug
      location.reload();
    },
    async resetAll() {
      this.setToken("");
      this.setUsername("游客");
      this.setAvatar("https://i.gtimg.cn/club/item/face/img/2/15922_100.gif");
      this.cityList = [];
      this.cityInfo = {};
      this.vipInfos = {};
      this.authCode = [];
      const aclStore = useAclStore();
      const routesStore = useRoutesStore();
      const tabsStore = useTabsStore();
      aclStore.setFull(false);
      tabsStore.delAllVisitedRoutes();
      routesStore.clearRoutes();
      sessionStorage.clear();
      localStorage.clear();
      await resetRouter();
      removeToken();
    }
  },
  // persist: true,
  persist: {
    storage: sessionStorage
  }
});